import { Container } from "react-bootstrap";

const Success = () => (
  <Container>
    <h1>Success</h1>
    <p>
      Thank you for your purchase. You're ready to go! Click on "Stubminer" in
      the nav bar to get started. To learn the basics, be sure to watch{" "}
      <a href="https://www.youtube.com/watch?v=bFp8DIhGfvo&list=PL_py24H3UDPvkfsYOYQODaX-xN7N27vCm">
        these tutorial videos
      </a>
      .
    </p>
    <p>
      Sometimes it take a couple of minutes for your account to be updated. If
      it looks like there was a problem with your subscription, please{" "}
      <a href="mailto:contact@stubminer.com">contact us</a>.
    </p>
  </Container>
);

export default Success;
